module.exports = __webpack_public_path__ + "static/media/sachin-1.ea350ae6.jpg";